<header class="dashboard mobile">
	<div>
		<mat-icon class="logo-img" routerLink="/dashboard-mobile" svgIcon="ss-logo"></mat-icon>
	</div>
	<div class="naviItems">
		<mat-icon (click)="openAppointments()" [matBadgeHidden]="cntAppointmentdsToday == 0" aria-hidden="false" class="fab-icon material-icons icon_color" matBadge="{{ cntAppointmentdsToday }}"
		          matBadgeColor="warn" matTooltip="{{ 'MAIN_APP_DASHBOARD.heutigeTermine' | translate }}">calendar_today
		</mat-icon>
		
		<mat-icon (click)="openTasks()" [matBadgeHidden]="cntTasks == 0" aria-hidden="false" class="fab-icon material-icons icon_color" matBadge="{{ cntTasks }}"
		          matBadgeColor="warn" matTooltip="{{ 'MAIN_APP_DASHBOARD.pendenteAufgaben' | translate }}">grading
		</mat-icon>
		
		<mat-icon (click)="openNotes()" [matBadgeHidden]="cntNotes == 0" aria-hidden="false" class="fab-icon material-icons icon_color" matBadge="{{ cntNotes }}"
		          matBadgeColor="warn" matTooltip="{{ 'MAIN_APP_DASHBOARD.notizen' | translate }}">assignment
		</mat-icon>
	</div>
	<div class=" burger-menu">
		<button (clicked)="speedMenuClicked($event)" (created)="speedMenuCreated()" [items]="menuItems" class="mat-basic" closeIconCss="e-icons e-close" ejs-speeddial id="speedDialMenu"
		        openIconCss="e-icons e-menu" position="TopRight"></button>
	</div>
</header>

<main *ngIf="showDashboard()" class="mobile dashboard no-footer">
	<app-dialog-layout>
		
		<div class="navigation" style="display: flex; ">
			<mat-icon class="high" routerLink="/adressen-mobile" style="color: #007bff;"> location_city</mat-icon>
			<mat-icon class="high" routerLink="/objekte-mobile" style="color: #5cb85c;"> recent_actors</mat-icon>
			<mat-icon class="high" routerLink="/termin-mobile" style="color: #f0ad4e;"> calendar_month</mat-icon>
			<mat-icon class="high" routerLink="/timeapp" style="color: #993399;"> manage_history</mat-icon>
		</div>
		
		<mat-accordion [multi]="false">
			<app-dialog-layout>
				<mat-expansion-panel [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title> Zuletzt verwendete Objekte</mat-panel-title>
					</mat-expansion-panel-header>
					<div *ngIf="hasLastViewedObjects == 1">
						<mat-spinner *ngIf="isLoadingObjectsResults" style="margin: 0 auto"></mat-spinner>
						<table [dataSource]="dataSourceObjekte" mat-table>
							<ng-container matColumnDef="objectNo">
								<th *matHeaderCellDef mat-header-cell>Obj.-Nr.</th>
								<td *matCellDef="let element" mat-cell>
									{{ element.objectNumber }}
								</td>
							</ng-container>
							
							<ng-container matColumnDef="typeDesc">
								<th *matHeaderCellDef mat-header-cell>Typ</th>
								<td *matCellDef="let element" mat-cell>
									{{ element.typeDescription }}
								</td>
							</ng-container>
							
							<ng-container matColumnDef="desc">
								<th *matHeaderCellDef mat-header-cell>Bezeichnung</th>
								<td *matCellDef="let element" mat-cell>
									{{ element.description }}
								</td>
							</ng-container>
							
							<ng-container matColumnDef="objekt">
								<th *matHeaderCellDef mat-header-cell>Objekt</th>
								<td *matCellDef="let element" mat-cell>{{ element.note4 }}</td>
							</ng-container>
							
							<tr *matHeaderRowDef="displayedObjektColumns" mat-header-row></tr>
							<tr (click)="highlight(row)" *matRowDef="let row; columns: displayedObjektColumns" [ngClass]="{ highlight: selectedObjectID == row.objectID }" mat-row></tr>
						</table>
					</div>
				</mat-expansion-panel>
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title> Zuletzt verwendete Adressen</mat-panel-title>
					</mat-expansion-panel-header>
					<div *ngIf="hasLastViewedAddresses == 1">
						<mat-spinner *ngIf="isLoadingAddressesResults" style="margin: 0 auto"></mat-spinner>
						<table [dataSource]="dataSourceAdressen" mat-table>
							<ng-container matColumnDef="adressNo">
								<th *matHeaderCellDef mat-header-cell>Adr.-Nr.</th>
								<td *matCellDef="let element" mat-cell>{{ element.adressNo }}</td>
							</ng-container>
							<ng-container matColumnDef="name">
								<th *matHeaderCellDef mat-header-cell>Name</th>
								<td *matCellDef="let element" mat-cell>{{ element.lastName }}</td>
							</ng-container>
							<ng-container matColumnDef="vorname">
								<th *matHeaderCellDef mat-header-cell>Vorname</th>
								<td *matCellDef="let element" mat-cell>{{ element.firstName }}</td>
							</ng-container>
							<ng-container matColumnDef="strasse">
								<th *matHeaderCellDef mat-header-cell>Strasse</th>
								<td *matCellDef="let element" mat-cell>{{ element.street1 }}</td>
							</ng-container>
							<tr *matHeaderRowDef="displayedAdresseColumns" mat-header-row></tr>
							<tr (click)="highlightAdr(row)" *matRowDef="let row; columns: displayedAdresseColumns" [ngClass]="{ highlight: selectedAdressID == row.adressID }" mat-row></tr>
						</table>
					</div>
				</mat-expansion-panel>
			</app-dialog-layout>
		</mat-accordion>
	</app-dialog-layout>
</main>

<router-outlet></router-outlet>
